import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as userActions from '../../actions/usersActions';
import * as gapiAction from '../../actions/gapiActions';
import moment from 'moment';
import { confirmAlert } from 'react-confirm-alert';
import DatePicker from 'react-datepicker';
import Switch from "react-switch";
// import { toastr } from 'react-redux-toastr';
import subDays from "date-fns/sub_days"
import * as message from '../../constants/messageConstants';
import classNames from 'classnames';
import validator from './../common/validator.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as SVGICONS from '../../images/img/images';
import * as constant from '../../constants/constant';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import $ from 'jquery'
import { Button } from 'react-bootstrap';
import CalendarEmailInput from '../calendar/CalendarEmailInput';

const errorFontSize = {
	fontSize: 11
}
let userId = localStorage.getItem('userId')

class MySetting extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			patternOne: false,
			patternTwo: false,
			patternThree: false,
			patternFour: false,
			popoverShow: false,
			bloodGroupList: [],
			replicaBloodGroupList: [],
			image: { value: '', isValid: true, message: '' },
			gender: { value: 'Male', isValid: true, message: '' },
			userName: { value: '', isValid: true, message: '' },
			phoneNo: { value: '', isValid: true, message: '' },
			email: { value: '', isValid: true, message: '' },
			dateOfBirth: { value: null, isValid: true, message: '' },
			userId: '',
			bloodGroup: { value: '', isValid: true, message: '' },

			phoneNoCountryCode: { value: localStorage.getItem('calling_code'), isValid: true, message: '' },
			//for instead reflect image change
			tabClicked: 1,
			imageCopy: '',
			file: '',
			imagePreviewUrl: '',
			defaultImageURL: '',

			//change Password
			currentPassword: { value: '', isValid: true, message: '' },
			password: { value: '', isValid: true, message: '' },
			cpassword: { value: '', isValid: true, message: '' },
			unsubscribe: { value: false, isValid: true, message: 'warning: we do not recommend you unsubscribe from all email notifications as appointment reminders and other important emails will not be sent.' },

			// calendar syncing
			userGoogleSyncOption: false,
			userOutlookSyncOption: false,
			useriCalendarSyncOption: false,



		}
		this.onChange = this.onChange.bind(this);
		this.updateUserProfile = this.updateUserProfile.bind(this);
		this.uploadPatientImage = this.uploadPatientImage.bind(this);
		this.onPasswordSettingChange = this.onPasswordSettingChange.bind(this);
		this.changePassword = this.changePassword.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.resetValidationStates = this.resetValidationStates.bind(this);
		this.deleteProfile = this.deleteProfile.bind(this);
		this.onrenderimage = this.onrenderimage.bind(this);
		this.deleteImage = this.deleteImage.bind(this);
		this.emailNotification = this.emailNotification.bind(this);
		this.unsubscribeEmailsViaProfile = this.unsubscribeEmailsViaProfile.bind(this);
	}
	unsubscribeEmailsViaProfile(event) {
		var state = this.state
		state.unsubscribe = { value: event.target.checked, isValid: true, message: 'warning: we do not recommend you unsubscribe from all email notifications as appointment reminders and other important emails will not be sent.' }
		this.setState(state)
		let obj = {
			isUnsubscribe: event.target.checked,
			userId: localStorage.getItem('userId')
		}
		this.props.actions.unsubscribeEmailsViaProfile(obj);
	}
	onChange(event) {
		var state = this.state;
		state[event.target.name].value = event.target.value;

		if (event.target.name == 'gender') {

			if (event.target.value == 'Male') {
				this.state.defaultImageURL = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_m.png'
			}
			else {
				this.state.defaultImageURL = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_f.png'
			}
		}

		//validation code
		if (event.target.name == "userName") {
			if (event.target.value.length > 0) {
				if (!validator.isValidName(event.target.value)) {
					state[event.target.name].isValid = false;
					state[event.target.name].message = 'Please enter a valid name';
				} else {
					state[event.target.name].isValid = true;
					state.userName.message = '';
				}
			} else {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Name is Required';
			}
		}
		else if (event.target.name == "email") {
			if (event.target.value.length > 0) {
				if (!validator.isEmail(state.email.value)) {
					state[event.target.name].isValid = false;
					state[event.target.name].message = 'Not a valid email address';
					this.setState(state);
				} else {
					state[event.target.name].isValid = true;
					state[event.target.name].message = '';
				}
			} else {
				state.email.isValid = false;
				state.email.message = 'Email address is required';
				this.setState(state);
			}

		} else if (event.target.name == "bloodGroup") {
			if (event.target.value == "") {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Blood group is required';
				this.setState(state);
			} else {
				state[event.target.name].isValid = true;
				state[event.target.name].message = '';
			}
		} else if (event.target.name == "phoneNo") {
			if ((event.target.value).length == 0) {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Phone number is required';
			} else if ((event.target.value).length > 10) {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Max allowed length is 10';
			} else if (!validator.isOnlyNumber(event.target.value)) {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Only numbers are allowed in phone number';
			} else if ((state.phoneNo.value).length < 10) {
				state.phoneNo.isValid = false;
				state.phoneNo.message = 'Min allowed length is 10';
			}
			else {
				state[event.target.name].isValid = true;
				state[event.target.name].message = ''
			}
		}

		this.setState(state);
	}
	resetValidationStates() {
		var state = this.state;

		Object.keys(state).map(key => {
			if (state[key].hasOwnProperty('isValid')) {
				state[key].isValid = true;
				state[key].message = '';
			}
		});
		this.setState(state);
	}

	deleteProfile() {

		confirmAlert({
			title: 'Confirm',
			message: 'Do you wish to Delete your account? ',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						var obj = {
							userId: localStorage.getItem('userId')
						}
						this.props.actions.deletePatientAccount(obj);
					}
				},
				{
					label: 'No',
					onClick: () => { }
				}
			]
		})
	}

	handleChange(date) {
		if (date && (date != null)) {
			this.setState({ dateOfBirth: { value: date, message: '', isValid: true } });
		} else {
			this.setState({ dateOfBirth: { value: date, message: 'Date of birth is required', isValid: false } });
		}

	}

	updateUserProfile(event) {

		event.preventDefault();

		var state = this.state;

		if (state.userName || !state.userName) {
			if (state.userName.value != undefined && state.userName.value != "") {
				if (!validator.isValidName(state.userName.value)) {
					state.userName.isValid = false;
					state.userName.message = 'Please enter a valid name';
					this.setState(state);
				} else {
					state.userName.isValid = true;
					state.userName.message = '';
					this.setState(state);
				}
			} else {
				state.userName.isValid = false;
				state.userName.message = 'Name is Required';
				this.setState(state);
			}
		} else {
			state.userName.isValid = false;
			state.userName.message = 'Name is Required';
			this.setState(state);
		}

		if (state.email || !state.email) {
			if ((state.email.value != undefined && state.email.value != "") || document.getElementById('email').value != '') {

				if (!validator.isEmail(state.email.value) && !validator.isEmail(document.getElementById('email').value)) {
					state.email.isValid = false;
					state.email.message = 'Not a valid email address';
					this.setState(state);
				} else {
					state.email.isValid = true;
					state.email.message = '';
					this.setState(state);
				}
			} else {
				state.email.isValid = false;
				state.email.message = 'Email address is required';
				this.setState(state);
			}

		} else {
			state.email.isValid = false;
			state.email.message = 'Email address is required';
			this.setState(state);
		}
		if (state.bloodGroup || !state.bloodGroup) {
			if (state.bloodGroup.value == "" || state.bloodGroup.value == undefined) {
				state.bloodGroup.isValid = false;
				state.bloodGroup.message = 'Blood group is required';
				this.setState(state);
			} else {
				state.bloodGroup.isValid = true;
				state.bloodGroup.message = '';
				this.setState(state);
			}
		} else {
			state.bloodGroup.isValid = false;
			state.bloodGroup.message = 'Blood group is required';
			this.setState(state);
		}
		if (state.phoneNo || !state.phoneNo) {

			if ((state.phoneNo.value == '' || state.phoneNo.value == undefined) && document.getElementById('phoneNo').value == '') {
				state.phoneNo.isValid = false;
				state.phoneNo.message = 'Phone number is required';
			} else if ((state.phoneNo.value).length > 10 || document.getElementById('phoneNo').value.length > 10) {
				state.phoneNo.isValid = false;
				state.phoneNo.message = 'Max allowed length is 10';
			} else if ((state.phoneNo.value).length < 10 || document.getElementById('phoneNo').value.length > 10) {
				state.phoneNo.isValid = false;
				state.phoneNo.message = 'Min allowed length is 10';
			}
			else if (!validator.isOnlyNumber(state.phoneNo.value) || !validator.isOnlyNumber(document.getElementById('phoneNo').value)) {
				state.phoneNo.isValid = false;
				state.phoneNo.message = 'Only numbers are allowed in phone number';
			}
			else {
				state.phoneNo.isValid = true;
				state.phoneNo.message = ''
			}
		}

		if (state.dateOfBirth || !state.dateOfBirth) {
			if (state.dateOfBirth.value == "" || state.dateOfBirth.value == undefined) {
				state.dateOfBirth.isValid = false;
				state.dateOfBirth.message = 'Date of birth is required';
				this.setState(state);
			} else {
				state.dateOfBirth.isValid = true;
				state.dateOfBirth.message = '';
				this.setState(state);
			}
		} else {
			state.dateOfBirth.isValid = false;
			state.dateOfBirth.message = 'Date of birth is required';
			this.setState(state);
		}


		if (this.state.userName.value != '' && this.state.phoneNo.value != '' && this.state.bloodGroup.value != '' && this.state.email.value != '' && this.state.dateOfBirth.value != '' && (this.state.phoneNo.message == '' || this.state.phoneNo.message == undefined) && (this.state.email.message == '' || this.state.email.message == undefined) && (this.state.userName.message == '' || this.state.userName.message == undefined) && (this.state.bloodGroup.message == '' || this.state.bloodGroup.message == undefined) && (this.state.dateOfBirth.message == '' || this.state.dateOfBirth.message == undefined)
			&& (this.state.gender.message == '' || this.state.gender.message == undefined)
		) {
			let user = {
				userName: this.state.userName.value,
				gender: this.state.gender.value,
				phoneNo: this.state.phoneNo.value,
				email: this.state.email.value,
				dateOfBirth: this.state.dateOfBirth.value,
				bloodGroup: this.state.bloodGroup.value,
				phoneNoCountryCode: this.state.phoneNoCountryCode.value ? this.state.phoneNoCountryCode.value : '+91'
			}
			console.log("dateOfBirth", this.state.dateOfBirth);
			this.props.actions.updateUserProfile(user);
		}
	}
	uploadPatientImage(event) {

		//To change the view immediately after uploading image 
		event.preventDefault();
		this.resetValidationStates();
		if (event.target.name == "image") {
			if (event.target.files.length > 0) {
				if (!validator.ImageValidateFormate(event.target.files[0])) {
					toast.error('Please choose following format jpeg, jpg, png, gif')
				} else if (!validator.fileValidateSize(event.target.files[0])) {
					toast.error('File size must be less than 10 MB.')

				} else {
					let reader = new FileReader();
					let file = event.target.files[0];
					console.log(file)
					this.setState({
						image: { value: file },
						defaultImageURL: file
					})

					console.log(this.state.defaultImageURL)
					reader.onloadend = () => {
						this.setState({
							file: file,
							defaultImageURL: reader.result
						});
					}
					console.log(this.state.defaultImageURL)
					reader.readAsDataURL(file);


					this.setState({ [event.target.name]: event.target.files[0] });
					let patientObj = {
						file: event.target.files[0],
						userId: localStorage.getItem('userId')
					}
					this.props.actions.uploadPatientImage(patientObj);
				}
			}

		}

	}

	// **************** change function password section *********************


	onPasswordSettingChange(e) {
		var state = this.state;
		state[e.target.name].value = e.target.value;
		this.resetValidationStates();
		if (e.target.name == "password") {
			this.setState({ popoverShow: true })
			if (e.target.value.length > 0) {
				if ((validator.atLeastOneLetter(state.password.value)) || (validator.atLeastOneCapitalLetter(state.password.value)) || (validator.atLeastOneNumber(state.password.value)) || (validator.atLeastEightCharacters(state.password.value))) {
					if (validator.atLeastOneLetter(state.password.value)) {
						state.patternOne = true;
					} else {
						state.patternOne = false;
					}
					if (validator.atLeastOneCapitalLetter(state.password.value)) {
						state.patternTwo = true;
					} else {
						state.patternTwo = false;
					}
					if (validator.atLeastOneNumber(state.password.value)) {
						state.patternThree = true;
					} else {
						state.patternThree = false;
					}
					if (validator.atLeastEightCharacters(state.password.value)) {
						state.patternFour = true;
					} else {
						state.patternFour = false;
					}
				} else {
					return true
				}
				if (state.patternOne && state.patternTwo && state.patternThree && state.patternFour) {
					state.password.isValid = true;
					state.password.message = '';
					state.popoverShow = false;
				} else {
					state.password.isValid = false;
					state.password.message = 'Not a valid password';
					state.popoverShow = true;
				}
			} else {
				state.patternOne = false;
				state.patternTwo = false;
				state.patternThree = false;
				state.patternFour = false;
				state.password.isValid = false;
				state.password.message = 'Password is required';
				state.popoverShow = false;
			}
		} else if (e.target.name == "cpassword") {
			if (e.target.value.length > 0) {
				if (state.password.value != state.cpassword.value) {
					state.cpassword.isValid = false;
					state.cpassword.message = 'Passwords do not match';
					this.setState(state);
				} else {
					return true
				}
			} else {
				state.cpassword.isValid = false;
				state.cpassword.message = 'Confirm password is required';
				this.setState(state);
			}

		} else
			if (e.target.name == "currentPassword") {
				if (e.target.value.length > 0) {
					if (!validator.isValid(state.currentPassword.value)) {
						state.currentPassword.isValid = false;
						state.currentPassword.message = 'Not a valid currentPassword';
						this.setState(state);
					} else {
						return true
					}
				} else {
					state.currentPassword.isValid = false;
					state.currentPassword.message = 'Current Password is required';
					this.setState(state);
				}
			}
		this.setState(state);
	}
	//api calling
	changePassword() {

		var state = this.state;
		if (state.password || !state.password) {
			this.setState({ popoverShow: true })
			if (state.password.value.length > 0) {
				if ((validator.atLeastOneLetter(state.password.value)) || (validator.atLeastOneCapitalLetter(state.password.value)) || (validator.atLeastOneNumber(state.password.value)) || (validator.atLeastEightCharacters(state.password.value))) {
					if (validator.atLeastOneLetter(state.password.value)) {
						state.patternOne = true;
					} else {
						state.patternOne = false;
					}
					if (validator.atLeastOneCapitalLetter(state.password.value)) {
						state.patternTwo = true;
					} else {
						state.patternTwo = false;
					}
					if (validator.atLeastOneNumber(state.password.value)) {
						state.patternThree = true;
					} else {
						state.patternThree = false;
					}
					if (validator.atLeastEightCharacters(state.password.value)) {
						state.patternFour = true;
					} else {
						state.patternFour = false;
					}
				} else {
					// return true
					state.password.message = '';
					state.password.isValid = true;

				}
				if (state.patternOne && state.patternTwo && state.patternThree && state.patternFour) {
					state.password.isValid = true;
					state.password.message = '';
					state.popoverShow = false;
				} else {
					state.password.isValid = false;
					state.password.message = 'Not a valid password';
					state.popoverShow = true;
				}
			} else {
				state.patternOne = false;
				state.patternTwo = false;
				state.patternThree = false;
				state.patternFour = false;
				state.password.isValid = false;
				state.password.message = 'Password is required';
				state.popoverShow = false;
			}
		} if (state.cpassword || !state.cpassword) {
			if (state.cpassword.value.length > 0) {
				if (state.password.value != state.cpassword.value) {
					state.cpassword.isValid = false;
					state.cpassword.message = 'Passwords do not match';
					this.setState(state);
				} else {
					state.cpassword.isValid = true;
					state.cpassword.message = '';
				}
			} else {
				state.cpassword.isValid = false;
				state.cpassword.message = 'Confirm password is required';
				this.setState(state);
			}

		}
		if (state.currentPassword || !state.currentPassword) {
			if (state.currentPassword.value.length > 0) {
				if (!validator.isValid(state.currentPassword.value)) {
					state.currentPassword.isValid = false;
					state.currentPassword.message = 'Not a valid currentPassword';
					this.setState(state);
				} else {
					state.currentPassword.isValid = true;
					state.currentPassword.message = '';
				}
			} else {
				state.currentPassword.isValid = false;
				state.currentPassword.message = 'Current Password is required';
				this.setState(state);
			}
		}


		if (this.state.password.value != '' && this.state.cpassword.value != '' && this.state.currentPassword.value != '' && (this.state.password.message == '' || this.state.password.message == undefined) && (this.state.cpassword.message == '' || this.state.cpassword.message == undefined) && (this.state.currentPassword.message == '' || this.state.currentPassword.message == undefined) && (this.state.patternOne == true) && (this.state.patternTwo == true) && (this.state.patternThree == true) && (this.state.patternFour == true)) {
			if (this.state.password.value == this.state.cpassword.value) {
				let passwordObj = {
					userId: localStorage.getItem('userId'),
					oldPassword: this.state.currentPassword.value,
					newPassword: this.state.password.value
				}
				this.props.actions.changePassword(passwordObj);
				this.setState({
					currentPassword: { value: '' },
					password: { value: '' },
					cpassword: { value: '' },
					popoverShow: false
				});

			} else {
				toast.error(message.PASSWORDS_DIFFERENT);
				this.setState({
					currentPassword: { value: '' },
					password: { value: '' },
					cpassword: { value: '' },
					popoverShow: false
				});
			}
		}

	}

	componentWillMount() {
		let userDetail = {
			userId: localStorage.getItem('userId')
		}
		// this.setState({ ...this.state.phoneNoCountryCode, value: localStorage.getItem('calling_code') });
		console.log(this.state.phoneNoCountryCode)
		this.props.actions.getUserDetails(userDetail);
		this.props.actions.getBloodGroupList();
		// this.props.actions.getBloodGroupList();
		this.props.gapiAction.getUsersGoogleSyncStatus({ userId: userDetail.userId });
		this.props.gapiAction.getUsersOutlookSyncStatus({ userId: userDetail.userId });
		this.props.gapiAction.getUsersiCloudSyncStatus({ userId: userDetail.userId });


	}
	componentWillReceiveProps(nextProps) {

		console.log("usernexrprops=-===============change in state of props", nextProps)
		var state = this.state;
		state.userName = { value: (nextProps.userDetails.userName) ? nextProps.userDetails.userName : state.userName.value },
			state.gender = { value: nextProps.userDetails.gender ? nextProps.userDetails.gender : state.gender.value },
			state.image = { value: nextProps.userDetails.image ? nextProps.userDetails.image : state.image.value },
			state.bloodGroupList = (nextProps.bloodGroupList) ? nextProps.bloodGroupList : state.bloodGroupList,
			state.replicaBloodGroupList = (nextProps.bloodGroupList) ? nextProps.bloodGroupList : state.replicaBloodGroupList,
			state.email = { value: nextProps.userDetails.email ? nextProps.userDetails.email : state.email.value, email: nextProps.userDetails.email },
			state.dateOfBirth = { value: nextProps.userDetails.dateOfBirth ? new Date(nextProps.userDetails.dateOfBirth) : this.state.dateOfBirth.value },
			state.bloodGroup = { value: nextProps.userDetails.bloodGroup ? nextProps.userDetails.bloodGroup : state.bloodGroup.value },
			state.phoneNo = { value: nextProps.userDetails.phoneNo ? nextProps.userDetails.phoneNo : state.phoneNo.value },
			state.imageCopy = nextProps.userDetails.image ? nextProps.userDetails.image : state.imageCopy,
			state.phoneNoCountryCode = { value: nextProps.userDetails.phoneNoCountryCode ? nextProps.userDetails.phoneNoCountryCode : state.phoneNoCountryCode.value },
			state.unsubscribe = { value: nextProps.userDetails.isUnsubscribe ? nextProps.userDetails.isUnsubscribe : state.unsubscribe.value }
		this.setState({ state });

		if (nextProps.specialistListAssistant && nextProps.specialistListAssistant.userName) {
			this.setState({
				specialistAssistant: nextProps.specialistListAssistant
			})

		}

		if (this.state.bloodGroupList && this.state.bloodGroupList.length == 0) {
			this.props.actions.getBloodGroupList();
		}
		if (localStorage.getItem('isClicked') === "true") {
			localStorage.removeItem('isClicked')

			this.setState({
				tabCLicked: 1
			})

		}
		if (nextProps.gapi.urlToRedirect) {
			window.location.href = nextProps.gapi.urlToRedirect
		}
		if (nextProps.gapi.put_revoke_state == null) {
			toast.info("Calendar Access Is successfully Revoked")
			console.log("REmoved Successfully", nextProps)
			// window.location.href = nextProps.gapi.urlToRedirect
		}
		if (nextProps.gapi.put_revoke_state && nextProps.gapi.put_revoke_state.data) {
			toast.info("Calendar Access Is successfully Setup")
			console.log("REmoved Successfully", nextProps)
			// window.location.href = nextProps.gapi.urlToRedirect
		}
		if (nextProps.gapi.user_google_sync_option !== null) {
			this.setState({ userGoogleSyncOption: nextProps.gapi.user_google_sync_option })
		}
		if (nextProps.gapi.user_outlook_sync_option !== null) {
			this.setState({ userOutlookSyncOption: nextProps.gapi.user_outlook_sync_option })
		}
		if (nextProps.gapi.user_icloud_sync_option !== null) {
			this.setState({ useriCalendarSyncOption: nextProps.gapi.user_icloud_sync_option })
		}
	}
	componentDidMount() {

		this.setState({
			tabCLicked: 1
		})
		// this.setState({ ...this.state.phoneNoCountryCode, value: localStorage.getItem('calling_code') });


		this.props.actions.getBloodGroupList();
	}
	onChangeTab(data) {

		this.setState({

			tabCLicked: data
		});

	}
	deleteImage() {
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

		var delImage = {
			userId: user._id,
			userType: 'Patient'
		}
		this.props.actions.deleteImageProfile(delImage);
	}
	onrenderimage() {
		if (this.state.imageCopy == '' || this.state.imageCopy == 'noUserImage.jpg') {

			if (this.state.gender.value == 'Male') {
				this.state.defaultImageURL = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_m.png'
			}
			else {
				this.state.defaultImageURL = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_f.png'
			}
		}
		else {
			this.state.defaultImageURL = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + '/' + localStorage.getItem('userId') + '/' + this.state.imageCopy
		}
	}
	emailNotification() {
		confirmAlert({
			title: '',
			message: 'Change of email address will logout your session and send a verification to your updated email address.  Please follow the instructions in the email to reactivate your account',
			buttons: [
				{
					label: 'OK',
					onClick: () => { }
				},

			]
		})

	}

	syncWithGoogle = (data) => {
		this.setState({ userGoogleSyncOption: !this.state.userGoogleSyncOption })

		confirmAlert({
			title: 'Confirm',
			message: `Do you really want to ${data == true ? 'sync' : 'unsync'} Google Calendar`,
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						if (data == true)
							this.props.gapiAction.getGapiAuth();
						if (data == false) {
							let bodyData = {
								code: "",
								action: 'REVOKE'
							}
							this.props.gapiAction.putGapiToken(bodyData, this.props);
						}
						// this.props.gapiAction.getOutlookAuth();
						// if (data == 3)
						// 	this.setState({ icloudEmailInput: true })
						// this.props.usersAction.deleteUser(userObject, userId);
					}
				},
				{
					label: 'No',
					onClick: () => {
						this.props.gapiAction.getUsersGoogleSyncStatus({ userId });
					}
				}
			]
		})



	}
	syncWithOutlook = (data) => {
		this.setState({ userOutlookSyncOption: !this.state.userOutlookSyncOption })

		confirmAlert({
			title: 'Confirm',
			message: `Do you really want to ${data == true ? 'sync' : 'unsync'} appointments with  Outlook Calendar`,
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						if (data == true)
							this.props.gapiAction.getOutlookAuth();
						if (data == false) {
							let bodyData = {
								code: "",
								action: 'REVOKE'
							}
							this.props.gapiAction.putOutlookToken(bodyData, this.props);
						}
						// this.props.gapiAction.getOutlookAuth();
						// if (data == 3)
						// 	this.setState({ icloudEmailInput: true })
						// this.props.usersAction.deleteUser(userObject, userId);
					}
				},
				{
					label: 'No',
					onClick: () => {
						this.props.gapiAction.getUsersOutlookSyncStatus({ userId });
					}
				}
			]
		})



	}
	// unSyncWithGoogle = (data) => {
	// 	let bodyData = {
	// 		code: "",
	// 		action: 'REVOKE'
	// 	}
	// 	confirmAlert({
	// 		title: 'Confirm',
	// 		message: `Do you really want to unsync appointments from ${data == 1 ? 'Google' : (data == 2 ? 'Outlook' : 'Apple')}  Calendar`,
	// 		buttons: [
	// 			{
	// 				label: 'Yes',
	// 				onClick: () => {
	// 					if (data == 1)
	// 						this.props.gapiAction.putGapiToken(bodyData, this.props);
	// 					// this.props.gapiAction.getGapiAuth();
	// 					if (data == 2)
	// 						this.props.gapiAction.putOutlookToken(bodyData, this.props)
	// 					if (data == 3)
	// 						this.props.gapiAction.storeUseriCloudEmail(bodyData, this.props)
	// 					// this.props.gapiAction.getOutlookAuth();
	// 					// this.props.usersAction.deleteUser(userObject, userId);
	// 					// this.props.usersAction.deleteUser(userObject, userId);
	// 				}
	// 			},
	// 			{
	// 				label: 'No',
	// 				// onClick: () => { this.props.history.push('specialist/my-settings'); }
	// 			}
	// 		]
	// 	})

	// }

	render() {
		localStorage.setItem('Gender', this.state.gender.value)
		var image = this.state.imageCopy
			? this.state.imageCopy : 'noUserImage.jpg';
		let { imagePreviewUrl } = this.state;
		var user = localStorage.getItem('user')? JSON.parse(localStorage.getItem('user')) : {};

		if (image != 'noUserImage.jpg') {
			imagePreviewUrl = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image
		} else {
			imagePreviewUrl = constant.PRODUCTION_IMAGE_URL + 'uploads/common/noUserImage.jpg';
		}
		let $imagePreview = null;
		if (!imagePreviewUrl) {
			var folderName = (image == constant.DEFAULT_USER_IMAGE) ? constant.COMMON_FOLDER : constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/';
			imagePreviewUrl = this.state.imageCopy
				? this.state.imageCopy : constant.PRODUCTION_IMAGE_URL + folderName + image;
		}
		var imagePath = "";

		if (user.image == constant.DEFAULT_USER_IMAGE) {
			imagePath = constant.PRODUCTION_IMAGE_URL + constant.COMMON_FOLDER + user.image;
		} else {
			imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		}
		{ this.onrenderimage() }

		var bloodGroupList = this.state.bloodGroupList;
		var countryCodeList = constant.PHONENOCOUNTRYCODE ? constant.PHONENOCOUNTRYCODE : [];


		return (

			<div className="content-wrapper">
				<section className="content container-fluid">
					<ToastContainer />
					{this.state.icloudEmailInput ? <CalendarEmailInput icloudEmailModalOpen={this.state.icloudEmailInput} icloudEmailModalClose={() => this.setState({ icloudEmailInput: false })} /> : ""}
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li><Link to="#" onClick={this.onChangeTab.bind(this, 1)} data-toggle="tab" className={this.state.tabCLicked === 1 ? "active show" : ''}>Profile</Link></li>
										<li><Link to="#" onClick={this.onChangeTab.bind(this, 2)} data-toggle="tab" className={this.state.tabCLicked === 2 ? "active show" : ''}>Password</Link></li>
										<li><Link to="#" onClick={this.onChangeTab.bind(this, 33)} data-toggle="tab" className={this.state.tabCLicked === 3 ? "active show" : ''}>Calendar</Link></li>
										<li><Link to="#" onClick={this.onChangeTab.bind(this, 3)} data-toggle="tab" className={this.state.tabCLicked === 3 ? "active show" : ''}>Delete Account</Link></li>
										<li><Link to="#" onClick={this.onChangeTab.bind(this, 4)} data-toggle="tab" className={this.state.tabCLicked === 4 ? "active show" : ''}>Subscriptions</Link></li>

									</ul>

									<div className="tab-content">
										<div className={this.state.tabCLicked === 1 ? "tab-pane active show" : 'tab-pane'} id="tab_1">
											<div className="settingInput">
												<div className="row">
													<div className="col-md-12">
														<form name="uploadimage" >
															<div className="userProImg">
																<div className="image">
																	<img className="original" src={this.state.defaultImageURL} alt="" />
																	<Link className="hover" onClick={this.deleteImage} ><i className="fa fa-trash"></i></Link>
																</div>

																<input type="file" className="form-control" ref="file" name="image" id="fileID" onChange={this.uploadPatientImage} onClick={(event) => { event.target.value = null }} style={{ 'display': 'none' }} />
																<label htmlFor="fileID" style={{ 'cursor': 'pointer' }}>
																	<SVGICONS.SpecialistProfileSvg />

																</label>
															</div>

														</form>
													</div>
												</div>

												<form>
													<div className="row">
														<div className="col-md-6">
															<div className="boxMrgB">
																<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa ">		<img src={require('../../images/img/user_input_icon.svg')} alt="" /></i></span>
																	<input type="text" name="userName" value={this.state.userName ? this.state.userName.value : ''} onChange={this.onChange} className="form-control text-capitalize" placeholder="Enter Name" />
																</div>
																<span className="help-block">{this.state.userName.message}</span>
															</div>
														</div>

														<div className="col-md-6">
															<div className="boxMrgB">
																<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/email_input_icon.svg')} alt="" /></i></span>
																	<input type="text" id="email" name="email" onChange={this.onChange} value={this.state.email ? this.state.email.value : ''} className="form-control" placeholder="Enter Email" />
																</div>
																<span className="help-block">{this.state.email.message}</span>
															</div>
															<div className=" margin-right posabr00 pull-right subRight helpsvg" >
																<span onClick={this.emailNotification}>
																	<SVGICONS.Helppic />
																</span>
															</div>
														</div>

														<div className="col-md-6">
															<div className="boxMrgB">
																<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/blood_input_icon.svg')} alt="" /></i></span>
																	<select className="form-control" style={{ border: 0 }} name="bloodGroup" value={this.state.bloodGroup ? this.state.bloodGroup.value : ''} onChange={this.onChange.bind(this)} >
																		<option value="">Select Blood Group </option>
																		{(bloodGroupList && bloodGroupList.length) > 0 ? bloodGroupList.map((option, index) => <option value={option._id} key={index}>{option.name}</option>) : ''}</select>
																</div>
																<span className="help-block">{this.state.bloodGroup.message}</span>
															</div>
														</div>

														<div className="col-md-6">
															<div className="boxMrgB">
																<div className="date-picker form__form-group-input-wrap form__form-group-input-wrap--error-above">
																	<div className="input-group date inputBg" style={{ color: '#4d4d4d !important' }}>
																		<div className="input-group-addon"><i className="fa ">
																			<img src={require('../../images/img/date_input_icon.svg')} /></i></div>
																		<DatePicker
																			name="dateOfBirth"
																			// dateFormat="DD-MMM-YYYY"
																			selected={this.state.dateOfBirth.value}
																			onChange={this.handleChange}
																			placeholderText="Date of Birth"
																			maxDate={new Date()}
																			// minDate={subDays(new Date(), 5)}
																			showMonthDropdown
																			showYearDropdown
																			shouldCloseOnSelect={true}
																			id='datepicker'
																		// readOnly={true}
																		/>
																	</div>
																	<span className="help-block">{this.state.dateOfBirth.message}</span>
																</div>
															</div>
														</div>

														<div className="col-md-6">
															<div className="row">
																<div className="col-md-2">
																	<div className="genderInfo ">Gender</div>
																</div>
																<div className="col-md-4 largescreencolumn5">
																	<div className="boxMrgB boxMrgT">
																		<div className="radio radio-primary">
																			<input type="radio" onChange={this.onChange} name="gender" id="gender1" value="Male" checked={this.state.gender.value === 'Male'} />
																			<label htmlFor="gender1"> Male </label>
																		</div>
																	</div>
																</div>
																<div className="col-md-4 largescreencolumn5">
																	<div className="boxMrgB boxMrgT landscape-radio">
																		<div className="radio radio-primary">
																			<input type="radio" name="gender" id="gender2" onChange={this.onChange} value="Female" checked={this.state.gender.value === 'Female'} />
																			<label htmlFor="gender2"> Female </label>
																		</div>
																	</div>
																</div>
															</div>
														</div>

														<div className="col-md-6">
															<div className="boxMrgB">
																<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/phone_input_icon.svg')} alt="" /></i></span>
																	<div className="dropdown cusmobile">
																		<select className="form-control" style={{ border: 0 }} name="phoneNoCountryCode" value={this.state.phoneNoCountryCode ? this.state.phoneNoCountryCode.value : '+91'} onChange={this.onChange.bind(this)} >
																			{(countryCodeList && countryCodeList.length) > 0 ? countryCodeList.map((option, index) => <option value={option ? option : ''} key={index}>{option}</option>) : ''}
																		</select>
																	</div>
																	<input id="phoneNo" style={{ marginLeft: 20 }} type="text" value={this.state.phoneNo ? this.state.phoneNo.value : ''} name="phoneNo" onChange={this.onChange} className="form-control p-d-20" placeholder="Phone Number" />
																</div>
																<span className="help-block">{this.state.phoneNo.message}</span>
															</div>
														</div>
														<div className="col-md-12 disclaimer_mysetting">
															<h3>Disclaimer</h3>
															<p>In order to maintain accurate records, all patients are required to submit personal details as they appear on official Government-issued documents.  The use of nicknames, pen-names, or other artistic references are not permitted. Where your personal details change, please update them on the Medfix website as soon as possible, and ensure all details supplied are to the best of your knowledge at all times.</p>
															<p>If, owing to regional, political or other reasons you are unable to submit your details in the way Medfix are requesting them, please contact Medfix Support Team who will be happy to assist</p>
														</div>

														<div className="col-md-12 text-center">
															<div className="bottomBtn">
																<button type="button" onClick={this.updateUserProfile} className="btn btn-warning btn-lg" >Save</button>
															</div>
														</div>

													</div>
												</form>
											</div>
										</div>

										<div className={this.state.tabCLicked === 2 ? "tab-pane changePassword active show" : 'tab-pane changePassword'} id="tab_2">
											<h2 className="subTitle text-center">Change Password</h2>
											<form>
												<div className="row">
													<div className="col-md-4 offset-md-4">
														<div className="boxMrgB toolTipDiv">
															<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/password_input_icon.svg')} alt="" /></i></span>
																<input type="password" name="currentPassword" className="form-control"
																	placeholder="Password" value={this.state.currentPassword.value} onChange={this.onPasswordSettingChange} placeholder="Current Password" />

																{/* <input type="password" name="currentPassword" className="form-control" onChange={this.onPasswordSettingChange} value={this.state.currentPassword} placeholder="Current Password" /> */}
															</div>
															<span className="help-block">{this.state.currentPassword.message}</span>


														</div>

														<div className="boxMrgB">
															<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/password_input_icon.svg')} alt="" /></i></span>
																<input type="password" name="password" className="form-control"
																	placeholder="New Password" value={this.state.password.value} onChange={this.onPasswordSettingChange} />

																{/* <input type="password" onChange={this.onPasswordSettingChange} name="newPassword" value={this.state.newPassword} className="form-control" placeholder="Enter New Password" /> */}
															</div>
															<span className="help-block">{this.state.password.message}</span>
															{this.state.popoverShow == true ? <div className="toolTip tooltipPass">
																<div className="tool_box mysetting_tool_box">
																	<p>Password must Meet the following
                                          requirements:
                                       </p>
																	<ul>
																		<li>{this.state.patternOne == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>} At least one letter</li>
																		<li>{this.state.patternTwo == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}At least one capital letter</li>
																		<li>{this.state.patternThree == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}At least one number</li>
																		<li>{this.state.patternFour == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}Be at least 8 characters	</li>
																	</ul>
																</div>
															</div> : ''}
														</div>

														<div className="boxMrgB">
															<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/password_input_icon.svg')} alt="" /></i></span>
																<input type="password" className="form-control" id="cpassword" ref="cpassword" name="cpassword" placeholder="Confirm Password" value={this.state.cpassword.value} onChange={this.onPasswordSettingChange} />

																{/* <input type="password" className="form-control" name="newConfirmPassword" onChange={this.onPasswordSettingChange} value={this.state.newConfirmPassword} placeholder="Re-enter New Password" /> */}
															</div>
															<span className="help-block">{this.state.cpassword.message}</span>
														</div>
													</div>
													<div className="col-md-12 text-center">
														<div className="bottomBtn">
															<button type="button" onClick={this.changePassword} className="btn btn-warning btn-lg">Update</button>
														</div>
													</div>
												</div>
											</form>
										</div>
										<div className={this.state.tabCLicked === 33 ? "tab-pane changePassword active" : "tab-pane changePassword"} id="tab_33">

											{/* <h2 className="text-center">Stripe Settings</h2> */}
											<h3>Calendar Integration</h3>
											<div className="bottomBtn">
												<label htmlFor="material-switch1" >
													<Switch
														checked={this.state.userOutlookSyncOption}
														onChange={() => {
															if (this.state.userOutlookSyncOption) {
																this.syncWithOutlook(false);
															} else {
																this.syncWithOutlook(true)
															}
															this.setState({ userOutlookSyncOption: this.state.userOutlookSyncOption })
														}}
														onColor="#86d3ff"
														onHandleColor="#2693e6"
														handleDiameter={30}
														uncheckedIcon={false}
														checkedIcon={false}
														boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
														activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
														height={20}
														// value={this.state.userOutlookSyncOption}
														// onValueChange={(value) => {
														// 	this.setState({
														// 		userOutlookSyncOption: value
														// 	}) }}
														width={48}
														className="react-switch"
														id="material-switch1"
													/>
													<span>Outlook Calendar</span>
												</label>
												{/* <Switch onChange={this.handleGoogleSwitchChange} checked={this.state.checked} /> */}
											</div>
											<div className="bottomBtn">
												<label htmlFor="material-switch2" >
													<Switch
														checked={this.state.userGoogleSyncOption}
														onChange={() => {
															if (this.state.userGoogleSyncOption) {
																this.syncWithGoogle(false);
															} else {
																this.syncWithGoogle(true)
															}
															this.setState({ userGoogleSyncOption: this.state.userGoogleSyncOption })
														}}
														onChange={this.syncWithGoogle}
														onColor="#86d3ff"
														onHandleColor="#2693e6"
														handleDiameter={30}
														uncheckedIcon={false}
														checkedIcon={false}
														boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
														activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
														height={20}
														width={48}
														className="react-switch"
														id="material-switch2"
													/>
													<span> Google Calendar</span>
												</label>
												{/* <Switch onChange={this.handleGoogleSwitchChange} checked={this.state.checked} /> */}
											</div>

											{/* <div className="col-md-12 text-center">
													{!this.state.userGoogleSyncOption ? <button onClick={() => this.syncWithGoogle(1)} class="btn btn-info btn-lg">
														<span class="glyphicon glyphicon-calendar"></span> Google Calendar
		</button> :
														<button onClick={() => this.unSyncWithGoogle(1)} class="btn btn-warning btn-lg">
															<span class="glyphicon glyphicon-calendar"></span> Remove Google Calendar
			</button>}
													{!this.state.userOutlookSyncOption ? <button onClick={() => this.syncWithGoogle(2)} class="btn btn-info btn-lg">
														<span class="glyphicon glyphicon-calendar"></span> OutLook Calendar
		</button>
														: <button onClick={() => this.unSyncWithGoogle(2)} class="btn btn-warning btn-lg">
															<span class="glyphicon glyphicon-calendar"></span> Remove OutLook Calendar
		</button>}
													{!this.state.useriCalendarSyncOption ? <button onClick={() => this.syncWithGoogle(3)} class="btn btn-info btn-lg">
														<span class="glyphicon glyphicon-calendar"></span> Sync with iCalendar
		</button>
														: <button onClick={() => this.unSyncWithGoogle(3)} class="btn btn-warning btn-lg">
															<span class="glyphicon glyphicon-calendar"></span> Remove iCalendar
		</button>}
												</div>
												 */}
										</div>

										<div className={this.state.tabCLicked === 3 ? "tab-pane changePassword active show" : 'tab-pane changePassword'} id="tab_3">
											<div>
												<p className="AccountDeleteText">Warning! Account Deletion is a permanent process which cannot be reversed.  You will lose access to your account and will be required to re-register to use our services in the future.</p>
											</div>
											<div className="bottomBtn">
												<button type="button" onClick={this.deleteProfile.bind(this)} className="btn btn-warning btn-lg" >Delete Profile</button>
											</div>
										</div>
										<div className={this.state.tabCLicked === 4 ? "tab-pane changePassword active show" : 'tab-pane changePassword'} id="tab_4">
											<div>
												<div className="checkbox checkbox-primary checkboxInline">
													<input type="checkbox" name="unsubscribe" id="unsubscribe" onChange={this.unsubscribeEmailsViaProfile} checked={this.state.unsubscribe.value} />
													<label htmlFor="unsubscribe" className="startReview">
														<span>Unsubscribe from ALL email notification</span> </label>
												</div>

											</div>
											<span className="help-block marginleft40" style={{ errorFontSize }}>warning: we do not recommend you unsubscribe from all email notifications as appointment reminders and other important emails will not be sent.</span>

										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<div className="Copyrightafterlogin">
					<p>Medfix &copy; 2018. All rights reserved</p>
				</div>
			</div>

		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		userDetails: state.users.userDetails,
		bloodGroupList: state.users.bloodGroupList,
		gapi: state.gapi,

		//previous comment
		// latestPatientImage: state.users.latestPatientImage
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(userActions, dispatch),
		gapiAction: bindActionCreators(gapiAction, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(MySetting);
